import { render, staticRenderFns } from "./cabecalho-brasao.vue?vue&type=template&id=f83f361c"
import script from "./cabecalho-brasao.vue?vue&type=script&lang=js"
export * from "./cabecalho-brasao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports